<template>
  <div>
    <b-row>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t('patrol_logs.patrol_log.unit') }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="unitFilter"
          :options="unitOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          :placeholder="$t('patrol_logs.patrol_log.select_unit')"
          @input="(val) => $emit('update:unitFilter', val)"
        />
      </b-col>
       <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t('patrol_logs.patrol_log.revision_code') }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="revisionCodeFilter"
          :options="revisionCodeOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          :placeholder="$t('patrol_logs.patrol_log.select_revision_code')"
          @input="(val) => $emit('update:revisionCodeFilter', val)"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t('patrol_logs.patrol_log.command_officer') }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="commanderFilter"
          :options="agentOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          :placeholder="$t('patrol_logs.patrol_log.select_command_officer')"
          @input="(val) => $emit('update:commanderFilter', val)"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t('patrol_logs.patrol_log.patrol_officer') }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="officerFilter"
          :options="agentOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          :placeholder="$t('patrol_logs.patrol_log.select_patrol_officer')"
          @input="(val) => $emit('update:officerFilter', val)"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    vSelect,
  },
  props: {
    unitOptions: {
      type: Array,
      default: () => [],
    },
    unitFilter: {
      type: Array,
      default: null,
    },
    agentOptions: {
      type: Array,
      default: () => [],
    },
    commanderFilter: {
      type: Array,
      default: null,
    },
    officerFilter: {
      type: Array,
      default: null,
    },
    revisionCodeOptions: {
      type: Array,
      default: () => [],
    },
    revisionCodeFilter: {
      type: Array,
      default: null,
    },
  },
}
</script>
